import React from 'react';
import { Image, UserCheck, X } from 'lucide-react';
import styles from './IdentityTable.module.scss';
import StatusBadge from '../Shared/StatusBadge.tsx';

interface IdentityTableProps {
  users: any[];
  onViewImages: (user: any) => void;
  onValidate: (userId: string, isValid: boolean) => void;
}

const IdentityTable: React.FC<IdentityTableProps> = ({
  users,
  onViewImages,
  onValidate
}) => {
  return (
    <div className={styles.tableContainer}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>ID</th>
            <th>Nombre</th>
            <th>Email</th>
            <th>Estado</th>
            <th>Imágenes</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => (
            <tr key={index}>
              <td>{user.jobBoard?.id}</td>
              <td>{user.jobBoard?.name}</td>
              <td>{user.jobBoard?.email}</td>
              <td>
                <StatusBadge 
                  status={user.jobBoard?.identity_validated} 
                  type="identity"
                />
              </td>
               <td>
                <button
                  className={styles.viewButton}
                  onClick={() => onViewImages(user)}
                >
                  <Image size={16} />
                  Ver
                </button>
              </td>
              <td>
                {user.jobBoard?.identity_validated === null ? (
                  <div className={styles.actionButtons}>
                    <button
                      className={styles.approveButton}
                      onClick={() => onValidate(user.jobBoard?.id, true)}
                    >
                      <UserCheck size={16} />
                      Aceptar
                    </button>
                    <button
                      className={styles.rejectButton}
                      onClick={() => onValidate(user.jobBoard?.id, false)}
                    >
                      <X size={16} />
                      Rechazar
                    </button>
                  </div>
                ) : (
                  <button className={styles.approveButton} disabled>
                    <UserCheck size={16} />
                    Validado
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default IdentityTable;

